module.exports = __webpack_public_path__ + "static/img/posql.cde787a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/posql.png
// module id = I8+W
// module chunks = 0